import * as z from 'zod/mini';
import { CountryCode } from '../i18n/CountryCode.js';
export const PatientAddress = z.object({
    country: z.nullish(CountryCode),
    city: z.nullish(z.string()),
    street: z.nullish(z.string()),
    postCode: z.nullish(z.string()),
    state: z.nullish(z.string()),
});
//# sourceMappingURL=PatientAddress.js.map